import messages from './messages';

const Schema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.signup),
    block: 'signup',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.default),
        fields: ['headtitle', 'title', 'text', 'source_input'],
      },
    ],

    properties: {
      headtitle: {
        title: intl.formatMessage(messages.headline),
      },
      title: {
        title: intl.formatMessage(messages.title),
      },
      text: {
        title: intl.formatMessage(messages.text),
      },
      source_input: {
        title: intl.formatMessage(messages.source_input),
      },
    },
    required: [],
  };
};

export default Schema;
